import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

export const showToast = (type, message) => {
    if (type==="error") {
        toast.error(message, {
            position: "bottom-right"
        }); 
    } else if (type==="success") {
        toast.success(message, {
            position: "bottom-right"
        });
    } else if (type==="warning") {
        toast.warning(message, {
            position: "bottom-right"
        });
    } else if (type==="info") {
        toast.info(message, {
            position: "bottom-right"
        });
    }
}